"use client";

import { c as _c } from "react/compiler-runtime";
import CreateDropMetadataItems from "@/components/drops/create/utils/metadata/CreateDropMetadataItems";
import type { DropMetadata } from "@/entities/IDrop";
import { useState } from "react";
export default function CreateDropFullMobileMetadata(t0) {
  const $ = _c(32);
  const {
    metadata,
    onMetadataEdit,
    onMetadataRemove,
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const [key, setKey] = useState(null);
  const [value, setValue] = useState(null);
  let t2;
  if ($[0] !== disabled || $[1] !== key || $[2] !== onMetadataEdit || $[3] !== value) {
    t2 = e => {
      e.preventDefault();
      if (disabled) {
        return;
      }
      if (key && value) {
        onMetadataEdit({
          data_key: key,
          data_value: value
        });
        setKey(null);
        setValue(null);
      }
    };
    $[0] = disabled;
    $[1] = key;
    $[2] = onMetadataEdit;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onSubmit = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="tw-mb-0 tw-block tw-text-sm tw-font-medium tw-text-iron-300">Metadata</p>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== disabled || $[7] !== metadata || $[8] !== onMetadataRemove) {
    t4 = <CreateDropMetadataItems items={metadata} onMetadataRemove={onMetadataRemove} disabled={disabled} />;
    $[6] = disabled;
    $[7] = metadata;
    $[8] = onMetadataRemove;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = key ?? "";
  let t6;
  if ($[10] !== disabled) {
    t6 = e_0 => {
      if (!disabled) {
        setKey(e_0.target.value);
      }
    };
    $[10] = disabled;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== disabled || $[13] !== t5 || $[14] !== t6) {
    t7 = <input type="text" placeholder="Category" value={t5} onChange={t6} disabled={disabled} maxLength={100} className="tw-form-input tw-block tw-w-full tw-appearance-none tw-rounded-lg tw-border-0 tw-bg-iron-800 tw-py-2.5 tw-pr-3 tw-text-md tw-font-normal tw-leading-6 tw-text-iron-50 tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-800 tw-transition tw-duration-300 tw-ease-out placeholder:tw-text-iron-400 hover:tw-ring-iron-700 focus:tw-bg-iron-900 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400" />;
    $[12] = disabled;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = value ?? "";
  let t9;
  if ($[16] !== disabled) {
    t9 = e_1 => {
      if (!disabled) {
        setValue(e_1.target.value);
      }
    };
    $[16] = disabled;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== disabled || $[19] !== t8 || $[20] !== t9) {
    t10 = <input type="text" placeholder="Value" value={t8} onChange={t9} disabled={disabled} maxLength={500} className="tw-form-input tw-block tw-w-full tw-appearance-none tw-rounded-lg tw-border-0 tw-bg-iron-800 tw-py-2.5 tw-pr-3 tw-text-md tw-font-normal tw-leading-6 tw-text-iron-50 tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-800 tw-transition tw-duration-300 tw-ease-out placeholder:tw-text-iron-400 hover:tw-ring-iron-700 focus:tw-bg-iron-900 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400" />;
    $[18] = disabled;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== disabled) {
    t11 = <button type="submit" disabled={disabled} className="tw-inline-flex tw-items-center tw-rounded-lg tw-border-0 tw-bg-iron-800 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-iron-300 tw-ring-1 tw-ring-inset tw-ring-iron-700 tw-transition tw-duration-300 tw-ease-out hover:tw-bg-iron-700 focus:tw-z-10 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400">Add</button>;
    $[22] = disabled;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== onSubmit || $[25] !== t10 || $[26] !== t11 || $[27] !== t7) {
    t12 = <form onSubmit={onSubmit} className="tw-space-y-3 lg:tw-space-y-0">{t7}{t10}{t11}</form>;
    $[24] = onSubmit;
    $[25] = t10;
    $[26] = t11;
    $[27] = t7;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t12 || $[30] !== t4) {
    t13 = <div>{t3}{t4}{t12}</div>;
    $[29] = t12;
    $[30] = t4;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
}